var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"document-section"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.model.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }